import { Translate } from "@mui/icons-material";
import { Divider, Grid, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { MenuComponentProps } from "../RenderUserMenuOptions";
import { LanguageRenderList } from "./LanguageRenderList";

export interface ILanguageItem {
    title: string;
    onClick: (e?: any) => void;
    value: string;
}

export const LanguageRender: React.FC<MenuComponentProps> = ({
    FooterComponent,
    HeaderComponent,
    setAlertColor,
    setMessage,
    setPopupOk,
    index
}) => {

    const { i18n, t } = useTranslation();

    const languageOptions: ILanguageItem[] = [
        {
            title: "English (EN)",
            onClick: () => {
                i18n.changeLanguage("en-US")
            },
            value: "en-US"
        },
        {
            title: "Espanõl (ES)",
            onClick: () => {
                i18n.changeLanguage("es")
            },
            value: "es"
        },
        {
            title: "Português (BR)",
            onClick: () => {
                i18n.changeLanguage("pt-BR")
            },
            value: "pt-BR"
        },
    ];

    return (
        <Grid item xs={10} >
            <Grid container width="100%" height="100%">
                <HeaderComponent 
                    contentString={t("Language.SelectPreferIdiom")}
                    icon={<Translate fontSize="large" sx={{ color: "#22638D" }} />}
                    title={t("Language.Language")}
                    setAlertColor={setAlertColor}
                    setMessage={setMessage}
                    setPopupOk={setPopupOk}
                    index={index}
                />
                <Grid item xs={12}
                    display="flex"
                    justifyContent="space-evenly"
                    alignItems="center"
                    paddingTop={4}
                    paddingBottom={4}
                    gap={4}
                >
                    <LanguageRenderList
                        languageOptions={languageOptions}
                    />
                </Grid>
                <Grid item xs={12}>
                    <Typography
                        fontSize="14px"
                        color="#2D2D2D"
                        sx={{ opacity: .5 }}
                    >
                        {t("Language.NotFoundLanguage")}
                    </Typography>
                    <Divider
                        sx={{
                            marginTop: "20px",
                            opacity: .2,
                            borderColor: "#22638D",
                            
                        }}
                    />
                </Grid>
                <FooterComponent />
            </Grid>
        </Grid>
    )}